<script lang="ts">
  import DashboardLayout from '../DashboardLayout.svelte';
  import DashHero from '../shared/DashHero.svelte';
  import QuirofanoAgendaWidget from '../widgets/QuirofanoAgendaWidget.svelte';
  import QuickActions from '../widgets/QuickActions.svelte';
  import { Quirofano } from '../../../lib/api';

  let { onNavigate }: { onNavigate: (tab: string) => void } = $props();

  let stats = $state({ hoy: 0, curso: 0, prog: 0 });

  function hoyRango() {
    const d = new Date();
    const desde = new Date(d.getFullYear(), d.getMonth(), d.getDate()).toISOString();
    const hasta = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1).toISOString();
    return { desde, hasta };
  }

  async function cargar() {
    const { desde, hasta } = hoyRango();
    const all = await Quirofano.agenda(desde, hasta).catch(() => []);
    stats = {
      hoy: all.filter(c => c.estado !== 'CANCELADA').length,
      curso: all.filter(c => c.estado === 'EN_CURSO').length,
      prog: all.filter(c => c.estado === 'PROGRAMADA').length,
    };
  }

  const actions = [{ id: 'quirofano', label: 'Block quirúrgico', icon: '' }];

  $effect(() => { cargar(); const t = setInterval(cargar, 60000); return () => clearInterval(t); });
</script>

<DashboardLayout title="Block quirúrgico" subtitle="Agenda del día" variant="quirofano">
  <DashHero emoji='' title="Block quirúrgico" subtitle="Cirugías programadas y en curso" variant="quirofano" />
  <QuickActions {actions} onAction={onNavigate} />

  <div class="dash-kpis">
    <div class="dash-kpi"><div class="dash-kpi-label">Cirugías hoy</div><div class="dash-kpi-value">{stats.hoy}</div></div>
    <div class="dash-kpi"><div class="dash-kpi-label">En curso</div><div class="dash-kpi-value">{stats.curso}</div></div>
    <div class="dash-kpi"><div class="dash-kpi-label">Programadas</div><div class="dash-kpi-value">{stats.prog}</div></div>
  </div>

  <div class="dash-grid">
    <div class="col-12"><QuirofanoAgendaWidget limit={12} {onNavigate} /></div>
  </div>
</DashboardLayout>
